import * as React from "react";
import dynamic from "next/dynamic";
import styled, { createGlobalStyle } from "styled-components";
import { getValidModules } from "utils/playground/module";
import { HomeProps } from "../index";
import { litbBlankPoster } from "utils/playground/banner";
import { isNotBlankObject } from "utils";
import { Platform } from "utils/website";
import { isLocalDevelop } from "utils/debug";
import { onChangeHeaderLang } from "utils/lang";
import { setSentryCatchOnRequest } from "utils/sentryEvent";

import MegatronFrontForWeb from "./pages/Index";
import ErrorPage from "./components/ErrorPage";
import { WebHeader } from "litb-header";

const MainContainer = styled.section`
	min-height: 600px;
	min-width: 1200px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
`;
const GlobalStyle = createGlobalStyle`
	:root {
			--loaderWidth: 250px;
			--loaderDotSize: 20px;
		}
	html, body {
		font-size: 12px;
	}
`;
const WebFooter = dynamic(import("./components/Footer"), {
	ssr: false,
});
interface WebHomeState {
	hasDownloadBanner: boolean;
}

class WebHome extends React.Component<HomeProps, WebHomeState> {
	state: WebHomeState = {
		hasDownloadBanner: false,
	};
	constructor(props: HomeProps) {
		super(props);
	}

	render() {
		const { page, tagQuery, runtime } = this.props;
		const frontModules = getValidModules(this.props.frontModules);
		const isPageDisable = !page || page.isDisable;
		const defaultProps = {
			isDev: isLocalDevelop(runtime.hostname),
			isUat: runtime.isUat,
			cookies: runtime.cookies || {},
			runtime: {
				languageCode: runtime.languageCode,
				currency: runtime.currency,
				countryCode: runtime.countryCode3,
				countryCode2: runtime.countryCode2,
				sid: runtime.sid,
				sessionKey: runtime.sessionKey,
				platform: Platform.WEB,
				multiLanImgKey: runtime.multiLanImgKey,
			},
		};
		if (isPageDisable) {
			return (
				<React.Fragment>
					<WebHeader {...defaultProps} onSentryCatch={setSentryCatchOnRequest} />
					<ErrorPage key={"EMPTYPAGE"} />
				</React.Fragment>
			);
		}
		return (
			<main style={{ overflowX: "hidden", fontFamily: "Avenir-Roman,sans-serif" }}>
				<WebHeader
					{...defaultProps}
					onChangeLanguage={onChangeHeaderLang}
					onSentryCatch={setSentryCatchOnRequest}
				/>
				<MainContainer
					key={"PAGE"}
					style={{
						backgroundColor: page.ui.bgColor || "#f7f7f7",
					}}>
					<GlobalStyle />
					{isNotBlankObject(frontModules) ? (
						<MegatronFrontForWeb
							runtime={runtime}
							page={page}
							modules={frontModules}
							tagQuery={tagQuery}
						/>
					) : (
						<img className={"placeholder"} src={litbBlankPoster()} alt="" />
					)}
				</MainContainer>

				<section style={{ minHeight: "789px" }}>
					<WebFooter {...defaultProps} />
				</section>
			</main>
		);
	}
}

export default WebHome;
